/* Keep Shopify's customer form and CAPTCHA handling; enhance completed submissions in place. */
(() => {
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.tampino-footer .email-signup__form')) return;
    if (event.defaultPrevented || form.dataset.tampinoNativeRetry === 'true') return;

    const success = form.querySelector('.email-signup__message--success');
    const submit = event.submitter || form.querySelector('[type="submit"]');
    if (!success || !(submit instanceof HTMLElement)) return;

    event.preventDefault();
    submit.setAttribute('aria-busy', 'true');
    submit.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!response.ok || /\/challenge(?:\/|$)/.test(new URL(response.url).pathname)) throw new Error('Shopify requires native submission');

      const documentFromShopify = new DOMParser().parseFromString(await response.text(), 'text/html');
      const returnedSuccess = documentFromShopify.getElementById(success.id);
      const confirmedByShopify = returnedSuccess && !returnedSuccess.hasAttribute('hidden');
      const successRedirect = new URL(response.url).searchParams.get('customer_posted') === 'true';
      if (confirmedByShopify || successRedirect) {
        form.querySelector('[id^="Email-signup__message-error"]')?.remove();
        success.hidden = false;
        form.querySelector('input[type="email"]')?.setAttribute('aria-describedby', success.id);
        success.focus({ preventScroll: true });
        form.reset();
        return;
      }

      const returnedError = documentFromShopify.querySelector('[id^="Email-signup__message-error"]');
      if (returnedError) {
        form.querySelector('[id^="Email-signup__message-error"]')?.remove();
        const error = document.importNode(returnedError, true);
        success.before(error);
        const input = form.querySelector('input[type="email"]');
        input?.setAttribute('aria-invalid', 'true');
        input?.setAttribute('aria-describedby', error.id);
        input?.focus({ preventScroll: true });
        return;
      }
      throw new Error('Unrecognised Shopify form response');
    } catch (_) {
      // A challenge or non-standard response must use Shopify's original submission flow.
      form.dataset.tampinoNativeRetry = 'true';
      submit.disabled = false;
      form.requestSubmit(submit);
    } finally {
      submit.removeAttribute('aria-busy');
      submit.disabled = false;
    }
  });
})();
